/* -------------------------- Design imports start -------------------------- */
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { Box, Card, IconButton, Modal, Typography } from '@mui/material'
import Button from '../Button'
/* --------------------------- Design imports end --------------------------- */

/* ------------------------ Functional imports start ------------------------ */
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
/* ------------------------- Functional imports end ------------------------- */

interface Props {
  open: boolean
  setOpen: (open: boolean) => void
  message?: string
  confirmButtonProps: {
    text?: string
    onConfirm: () => void
    disabled: boolean
  }
}

/* -------------------------------------------------------------------------- */
/*                               Start Component                              */
/* -------------------------------------------------------------------------- */
export default function DiscardChangesModal(props: Props): ReactElement {
  /* ------------------------- Non state data start ------------------------- */
  const { open, setOpen, message, confirmButtonProps } = props
  const { t } = useTranslation()
  /* -------------------------- Non state data end -------------------------- */

  /* --------------------------- Flag states start -------------------------- */

  /* ---------------------------- Flag states end --------------------------- */

  /* --------------------------- Data states start -------------------------- */

  /* ---------------------------- Data states end --------------------------- */

  /* ----------------------- Callback functions start ----------------------- */
  const handleClose = (): void => {
    setOpen(false)
  }
  const handleConfirm = (): void => {
    confirmButtonProps.onConfirm()
    handleClose()
  }
  /* ------------------------ Callback functions end ------------------------ */

  /* ------------------------------------------------------------------------ */
  /*                             Render component                             */
  /* ------------------------------------------------------------------------ */
  return (
    <Modal open={open} onClose={handleClose}>
      <Card
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minWidth: 'min-content',
          width: '30vw',
          outline: 'none',
        }}
      >
        <Box display="flex" flexDirection="column" height="100%">
          <Box display="flex" justifyContent="space-between" alignItems="center" padding="16px">
            <Typography variant="h6" fontWeight="bold">
              {t('common:content.heading.discardChanges') + '?'}
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseRoundedIcon />
            </IconButton>
          </Box>
          <Box
            flexGrow={1}
            padding="16px"
            sx={{
              overflowY: 'auto',
            }}
          >
            <Typography variant="body1">
              {message || t('common:feedback.warn.unsavedChangesWillBeDiscarded')}
            </Typography>
          </Box>
          <Box display="flex" justifyContent="space-between" padding="16px">
            <Button variant="contained" color="inherit" onClick={handleClose}>
              {t('common:interaction.button.cancel')}
            </Button>
            <Button variant="contained" onClick={handleConfirm}>
              {confirmButtonProps.text || t('common:interaction.button.continue')}
            </Button>
          </Box>
        </Box>
      </Card>
    </Modal>
  )
}
